const MAX_LINE_LIMIT = {
    desktop: 5,
    mobile: 4,
};
const MAX_IMG_LIMIT = 3;
const DEFAULT_LINE_HEIGHT = '24px';

export { DEFAULT_LINE_HEIGHT as D, MAX_IMG_LIMIT as M, MAX_LINE_LIMIT as a };
